<template>
    <div v-if="provider">
      <!-- Datos generales -->
      <BCard>
        <BRow>
            <BCol cols="12"> <h4 class="mb-2"><b>Datos generales</b></h4> </BCol>
        </BRow>
          <BRow>
            <BCol cols="12" xl="6" >
              <table class="mt-2 mt-xl-0 w-100">
                <ViewData vsIcon="UserIcon" vsLabel="Name" :vsValue="provider.name"  />
                <ViewData vsIcon="UserIcon" vsLabel="CIF" :vsValue="provider.CIF" />
                <ViewData vsIcon="UserIcon" vsLabel="Postal Code" :vsValue="provider.postal_code" />
              </table>
            </BCol>
            <BCol cols="12" xl="6" >
              <table class="mt-2 mt-xl-0 w-100">
                <ViewData vsIcon="UserIcon" vsLabel="Province" :vsValue="provider.province.name"  />
                <ViewData vsIcon="UserIcon" vsLabel="City" :vsValue="provider.city" />
                <ViewData vsIcon="UserIcon" vsLabel="Address" :vsValue="provider.address" />
              </table>
            </BCol>
        </BRow>

        <BRow>
          <BCol cols="12" class="mt-2">
            <div class="d-flex flex-wrap">
                <BButton :to="{ name: 'providers-edit', params: { id: provider.id } }" variant="primary"> {{$t('Edit')}} </BButton>
                <BButton variant="outline-danger" class="ml-1" @click="deletePopupAxios(provider.id, `providers/${provider.id}`, 'providers')"> {{$t('Delete')}} </BButton>
            </div>
          </BCol>
        </BRow>
      </BCard>


      <!-- Datos de contacto -->
      <BCard>
        <BRow>
            <BCol cols="12"> <h4 class="mb-2"><b>Datos de contacto</b></h4> </BCol>
        </BRow>
        <BRow>
            <BCol cols="12" xl="6" >
              <table class="mt-2 mt-xl-0 w-100">
                <ViewData vsIcon="UserIcon" vsLabel="Email" :vsValue="provider.email"  />
              </table>
            </BCol>
            <BCol cols="12" xl="6" >
              <table class="mt-2 mt-xl-0 w-100">
                <ViewData vsIcon="UserIcon" vsLabel="Phone" :vsValue="provider.phone" />
              </table>
            </BCol>
            <!-- Notes -->
        </BRow>
      </BCard>

      <!-- Datos bancarios -->
      <BCard>
        <BRow>
            <BCol cols="12"> <h4 class="mb-2"><b>Datos bancarios</b></h4> </BCol>
        </BRow>
        <BRow>
            <BCol cols="12" xl="6" >
              <table class="mt-2 mt-xl-0 w-100">
                <ViewData vsIcon="UserIcon" vsLabel="IBAN" :vsValue="provider.IBAN"  />
              </table>
            </BCol>
            <BCol cols="12" xl="6" >
              <table class="mt-2 mt-xl-0 w-100">
                <ViewData vsIcon="UserIcon" vsLabel="SWIFT" :vsValue="provider.SWIFT" />
              </table>
            </BCol>
        </BRow>
      </BCard>

      <!-- Preferencias -->
      <BCard>
        <BRow>
            <BCol cols="12"> <h4 class="mb-2"><b>Preferencias</b></h4> </BCol>
        </BRow>
        <BRow>
            <BCol cols="12" xl="6" >
              <table class="mt-2 mt-xl-0 w-100">
                <ViewData vsIcon="UserIcon" vsLabel="Equivalence surcharge" :vsValue="provider.equivalence_surcharge"  />
                <ViewData vsIcon="UserIcon" vsLabel="End date" :vsValue="provider.end_date"  />
              </table>
            </BCol>
            <BCol cols="12" xl="6" >
              <table class="mt-2 mt-xl-0 w-100">
                <ViewData vsIcon="UserIcon" vsLabel="Payment method" :vsValue="provider.payment_method.name" />
              </table>
            </BCol>
        </BRow>
      </BCard>

      <!-- Datos adicionales -->
      <BCard>
        <BRow>
            <BCol cols="12"> <h4 class="mb-2"><b>Datos adicionales</b></h4> </BCol>
        </BRow>
        <BRow>
            <BCol cols="12" xl="6" >
              <table class="mt-2 mt-xl-0 w-100">
                <ViewData vsIcon="UserIcon" vsLabel="Status" :vsValue="statusCast" vsCheckbox  />
              </table>
            </BCol>
            <BCol cols="12" xl="6" >
              <table class="mt-2 mt-xl-0 w-100">
              </table>
            </BCol>
        </BRow>
      </BCard>
    </div>
</template>

<script>
import axios from '@axios';
import { computed, ref } from '@vue/composition-api';
import ViewData from '@/components/ViewData.vue';
import { BCard, BCol, BRow, BButton } from 'bootstrap-vue';
import router from '@/router';
import popups from '@/hooks/popups';

export default {
    components: { BRow, BCard, BCol, ViewData, BButton },
    setup() {
        const { deletePopupAxios } = popups()
        const provider = ref(null)

        axios.get(`providers/${router.currentRoute.params.id}`).then(response => {
            provider.value = response.data
        })

        const statusCast = computed(() => {
            return provider.value.status == 1 ? provider.value.status = true : provider.value.status = false
        })

        return {
            statusCast,
            provider,
            deletePopupAxios
        }
    },
}
</script>

<style>

</style>